import RecoveryPasswordForm from './RecoveryPasswordForm';

export default RecoveryPasswordForm;
